const endpoint = window.teftCardsFrontend.rest + 'teft-cards/v1/get-render';

function loadMore( button, block ) {
	button.disabled = true;
	const loadingAnimation = setTimeout( () => {
		block.classList.add( 'loading' );
	}, 1000 );
	fetch( endpoint + '?args=' + JSON.stringify( button.dataset ) )
		.then( ( response ) => response.json() )
		.then( ( data ) => {
			if ( data ) {
				clearTimeout( loadingAnimation );
				block.classList.remove( 'loading' );
				block.querySelector( '.teft-cards-grid' ).innerHTML += data.content;
				button.dataset.offset = parseInt( button.dataset.offset, 10 ) + parseInt( button.dataset.perpage, 10 );
				button.disabled = false;
				if ( ! data.nextContent ) {
					button.disabled = true;
					button.classList.add( 'inactive' );
				}
			}
		} );
}

const dynamicCardBlocks = document.querySelectorAll( '.teft-cards-grid-dynamic.has-load-more' );
for ( let i = 0; i < dynamicCardBlocks.length; i++ ) {
	const block = dynamicCardBlocks[ i ];
	const loadMoreButton = block.querySelector( '.teft-cards-grid--load-more' );
	loadMoreButton.addEventListener( 'click', ( e ) => loadMore( e.target, block ) );
}
